import { Action } from '@agile-actors/actions/js';

const namespaceAction = Action('@@UI/MODAL');

const openModal = namespaceAction('OPEN');
const closeModal = namespaceAction('CLOSE');

export { openModal, closeModal };
